import type { EstadoEnvio } from "../../services/notificaciones-service";

/** Etiqueta y color (token de la paleta) de cada estado de envío en la bitácora. */
export const ESTADO_ENVIO: Record<EstadoEnvio, { etiqueta: string; color: string }> = {
  Pendiente: { etiqueta: "Pendiente", color: "slate" },
  Enviando: { etiqueta: "Enviando", color: "info" },
  Enviado: { etiqueta: "Enviado", color: "exito" },
  Entregado: { etiqueta: "Entregado", color: "exito" },
  Leido: { etiqueta: "Leído", color: "exito" },
  Reintentando: { etiqueta: "Reintentando", color: "advertencia" },
  Fallido: { etiqueta: "Fallido", color: "peligro" },
  Omitido: { etiqueta: "Omitido", color: "slate" },
  NoEntregado: { etiqueta: "No entregado", color: "peligro" },
};

export const ESTADOS_FILTRABLES: EstadoEnvio[] = ["Enviado", "Reintentando", "Fallido", "Omitido", "Pendiente"];
